import React, {PropTypes} from 'react';
import FormInput from './forminput.react';

export default class TimeInput extends FormInput {
  static propTypes = {
    action: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    pattern: PropTypes.string,
    inputTitle: PropTypes.string,
    value: PropTypes.string.isRequired
  }

  render() {
    const {action, name, inputTitle, title, value} = this.props;
    return (
      <div className="form-group">
        <label>{title}</label>
        <input className="form-control" title={inputTitle} name={name} onChange={action}
        type="time" value={value} />
      </div>
    );
  }
}
